<template>
  <div v-bind="$attrs">
    <b-btn :id="$options.name">Move</b-btn>
    <b-popover :ref="popoverRef" placement="bottom" :target="$options.name" class="popover">
      <label>{{ $t('labels.common.order') }}</label>
      <multiselect
        v-model="salesOrder" label="descriptor"
        :class="{ required: !salesOrder }"
        track-by="descriptor" placeholder="" open-direction="bottom"
        :options="salesOrders" internal-search :max-height="200"
        searchable :hide-selected="false"/>
      <hr style="margin: 10px -13px">
      <b-btn variant="success" @click="movePackages">Move packages</b-btn>
    </b-popover>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import { mapState } from 'vuex'
import { notificationsRenderer } from '@/helpers/renderHelpers'

export default {
  name: 'MoveBtnSalesOrder',
  components: { Multiselect },
  data () {
    return {
      salesOrder: null,
      packets: [],
      movements: []
    }
  },
  computed: {
    ...mapState('woodware', ['salesOrders']),
    popoverRef () {
      return `${this.$options.name}-popover`
    }
  },
  async created () {
    await this.$store.dispatch('woodware/loadSalesOrders')
  },
  methods: {
    async movePackages () {
      this.$emit('getSelected', ({ selectedPackets, selectedMovements }) => {
        this.packets = selectedPackets
        this.movements = selectedMovements
      })

      if ((!this.packets.length && !this.movements.length) || !this.salesOrder) {
        return notificationsRenderer('Please select packages and sales order', 'error')
      }

      const { salesOrder: { id: newOrderId }, packets, movements, popoverRef } = this
      const packetsToMove = packets.map(item => item.id)
      const movementsToMove = movements.map(item => item.id)
      try {
        await this.$http.post(`sales/salesordersitems/${newOrderId}/move_shipment/`, {
          packetsToMove, movementsToMove
        })
        this.clear()
        await this.$store.dispatch('salesOrder/loadShipments', {id: this.$route.params.id});
        this.$refs[popoverRef].$emit('close')
      } catch (error) {
        notificationsRenderer(error.data, 'error')
      }
    },
    clear () {
      this.packets = []
      this.movements = []
      this.salesOrder = null
    }
  }
}
</script>
<style scoped lang="sass">
.popover
  width: 600px
</style>


// WEBPACK FOOTER //
// src/components/common/sales-order/MoveBtnSalesOrder.vue